import { Mail, MapPin, Phone } from "lucide-react";
import { MedpaxMark } from "./MedpaxLogo";

export const Contact = () => {
    const year = new Date().getFullYear();
    return (
        <section
            id="contact"
            data-testid="contact-section"
            className="py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-12 gap-10 lg:gap-16">
                    <div className="col-span-12 lg:col-span-5 min-w-0">
                        <p className="overline text-[var(--slate)]">
                            Contact
                        </p>
                        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl mt-6 text-[var(--ink)] leading-[1.05] break-words">
                            We read every message,
                            <span className="italic text-[var(--ink-line)]">
                                {" "}
                                and reply to most.
                            </span>
                        </h2>
                        <p className="mt-6 text-[var(--slate)] leading-relaxed max-w-md">
                            For press, partnerships, or product support,
                            reach out using any of the details on the right.
                        </p>
                    </div>

                    <div className="col-span-12 lg:col-span-7 min-w-0">
                        <ul className="space-y-1">
                            <ContactRow
                                Icon={Mail}
                                label="Email"
                                value="info@medpax.org"
                                href="mailto:info@medpax.org"
                                testid="contact-email"
                            />
                            <ContactRow
                                Icon={Phone}
                                label="Telephone"
                                value="+1 361-571-7662"
                                href="tel:+13615717662"
                                testid="contact-phone"
                            />
                            <ContactRow
                                Icon={MapPin}
                                label="Mailing address"
                                value="823 Sitwell Dr., Rockwall, Texas 75087, USA"
                                testid="contact-address"
                            />
                        </ul>
                    </div>
                </div>
            </div>

            <footer
                data-testid="site-footer"
                className="mt-24 border-t border-[var(--line)]"
            >
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-sm text-[var(--slate)]">
                    <p className="font-display text-lg text-[var(--ink)] flex items-center gap-2">
                        <MedpaxMark size={18} color="currentColor" />
                        Medpax, LLC
                    </p>
                    <p>
                        © {year} Medpax, LLC. All rights reserved. ·
                        medpax.org
                    </p>
                </div>
            </footer>
        </section>
    );
};

const ContactRow = ({ Icon, label, value, href, testid }) => {
    const inner = (
        <div className="grid grid-cols-12 gap-4 items-center py-6 border-b border-[var(--line)]">
            <div className="col-span-12 md:col-span-4 flex items-center gap-3 overline text-[var(--slate)]">
                <Icon className="h-3.5 w-3.5" />
                {label}
            </div>
            <div className="col-span-12 md:col-span-8 min-w-0 font-display text-xl sm:text-2xl text-[var(--ink)] group-hover:text-[var(--ink-line)] transition-colors break-words">
                {value}
            </div>
        </div>
    );
    return (
        <li>
            {href ? (
                <a
                    href={href}
                    data-testid={testid}
                    className="group block"
                >
                    {inner}
                </a>
            ) : (
                <div data-testid={testid}>{inner}</div>
            )}
        </li>
    );
};
